import { UpdatePasswordRotationDocument } from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useUpdatePasswordRotation() {
  const session = useCurrentSession()
  const [mutation, { loading }] = useMutation(UpdatePasswordRotationDocument, {
    extractorFn: (data) => data.securitySettingsMutations.updateSecuritysettingsCompanyConfig,
  })

  const updatePasswordRotation = useUnsafeCallback(
    (passwordRotationEnabled: boolean, passwordRotationExpireInterval: number) => {
      return mutation({
        variables: {
          companyId: session.company.id,
          passwordRotationEnabled: passwordRotationEnabled,
          passwordRotationExpireInterval: passwordRotationExpireInterval,
        },
      })
    },
    [mutation, session.company.id]
  )

  return {
    updatePasswordRotation,
    loading,
  }
}
